import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

export default function ImageAnalysisPanel({ attachment, onClose }) {
  const { t } = useTranslation();
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);
  return createPortal(
    <div className="ai-analysis-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="ai-analysis-panel" onClick={(e) => e.stopPropagation()}>
        <header>
          <strong>{t("aiDevelopment.aiAnalysis")}</strong>
          <button type="button" aria-label={t("common.close")} onClick={onClose}>
            ✕
          </button>
        </header>
        {!attachment ? (
          <p>{t("aiDevelopment.imageLoadError")}</p>
        ) : (
          <>
            <dl>
              <dt>{t("aiDevelopment.analysisStatus")}</dt>
              <dd>{attachment.analysisStatus}</dd>
              {attachment.analysisModel && (
                <>
                  <dt>{t("aiDevelopment.analysisModel")}</dt>
                  <dd>{attachment.analysisModel}</dd>
                </>
              )}
              {attachment.createdAt && (
                <>
                  <dt>{t("aiDevelopment.analysisDate")}</dt>
                  <dd>{new Date(attachment.createdAt).toLocaleString()}</dd>
                </>
              )}
            </dl>
            <p className="ai-analysis-text">
              {attachment.analysisStatus === "FAILED"
                ? attachment.analysisText || t("aiDevelopment.analysisFailed")
                : attachment.analysisText || t("aiDevelopment.analysisPending")}
            </p>
          </>
        )}
      </div>
    </div>,
    document.body
  );
}
